export const routes = [
  {
    path: '/cardapio',
    label: 'Cardápio',
    elementId: 'plk-menu-btn',
  },
  {
    path: 'https://popeyes.harmo.me/',
    label: 'Restaurantes',
    elementId: 'plk-restaurants-btn',
    blank: true,
  },
  {
    path: '/cupons',
    label: 'Cupons',
    elementId: 'plk-coupons-btn',
  },
  {
    path: '/#delivery',
    label: 'Delivery',
    elementId: 'plk-delivery-btn',
  },
  {
    path: '/fale-conosco',
    label: 'Fale Conosco',
    elementId: 'plk-contact-us-btn',
  },
]
